import { Stack, Typography } from "@mui/material";
import { ReuseModal } from "../ReuseModal";

export const RestartAnalysisModal = ({
  totalCompanies,
  onSubmit,
  isOpen,
  isLoading,
  onClose,
}: {
  totalCompanies: number;
  onSubmit: () => void;
  isOpen: boolean;
  isLoading: boolean;
  onClose: () => void;
}) => {
  const onSubmitHandler = () => {
    onSubmit();
  };

  return (
    <ReuseModal
      icon="warn"
      isOpen={isOpen}
      onClose={onClose}
      onSubmit={onSubmitHandler}
      title="Change Roles Composition?"
      customText={
        <Stack gap="24px">
          <Typography variant="body1" color="text.secondary">
            After changing the buying committee roles composition, the discovery
            <strong>
              {` analysis will be recalculated for ${totalCompanies} accounts.`}
            </strong>
          </Typography>
          <Typography variant="body1" color="text.secondary">
            Previous results will be overwritten to reflect new composition.
          </Typography>
        </Stack>
      }
      submitBtnText="Continue"
      maxWidth="430px"
      isLoading={isLoading}
      isDisabled={isLoading}
      isDisabledCancelBtn={isLoading}
    />
  );
};
